const cleanApiUrl = import.meta.env.VITE_API_URL?.replace(/[^a-zA-Z0-9:/._-]/g, '') || '';

let landingLocationRecorded = false;

const getLandingOperationsPayload = () => ({
  path: `${window.location.pathname}${window.location.search}`,
  referrer: document.referrer || null,
  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || null,
  language: navigator.language || null,
});

export const recordLandingOperationalLocationVisit = () => {
  if (landingLocationRecorded || !cleanApiUrl || typeof window === 'undefined') {
    return;
  }

  landingLocationRecorded = true;

  void fetch(`${cleanApiUrl}/landing/operations/location`, {
    method: 'POST',
    credentials: 'omit',
    cache: 'no-store',
    keepalive: true,
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(getLandingOperationsPayload()),
  }).catch(() => {
    // Operational location counters must never affect the landing page UX.
  });
};
